export const BOOK_NUMBER_TYPE = {
  PAGES: 'Pages',
  SHEETS: 'Sheets',
  SCREENS: 'Screens'
};

export const SCREEN = {
  MANAGER: '/edit/manager',
  PRINT: '/edit/print',
  DIGITAL: '/edit/digital'
};

export const APPROVAL_DAYS = 10;

export const COVER_TYPE = {
  HARDCOVER: 'Hard Cover',
  SOFTCOVER: 'Soft Cover'
};

export const DELIVERY_OPTION = {
  BULK_SHIPPED: 'Bulk Ship To School',
  DIRECT_SHIPPED: 'Direct Ship To Home'
};
